export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14105.557b3f3f.jpg";